/* Compatibility helpers for the extra (Dawn-based) sections: product-form.js,
   product-info.js and friends expect these Dawn globals. Safe to load once per page. */
(function () {
  if (window.__kvCompat) return;
  window.__kvCompat = true;

  window.ON_CHANGE_DEBOUNCE_TIMER = window.ON_CHANGE_DEBOUNCE_TIMER || 300;
  window.PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    optionValueSelectionChange: 'option-value-selection-change',
    variantChange: 'variant-change',
    cartError: 'cart-error'
  };

  var subscribers = {};
  if (typeof window.subscribe !== 'function') {
    window.subscribe = function (eventName, callback) {
      (subscribers[eventName] = subscribers[eventName] || []).push(callback);
      return function () {
        subscribers[eventName] = (subscribers[eventName] || []).filter(function (cb) { return cb !== callback; });
      };
    };
  }
  if (typeof window.publish !== 'function') {
    window.publish = function (eventName, data) {
      var list = subscribers[eventName] || [];
      return Promise.all(list.map(function (cb) { return cb(data); }));
    };
  }
  if (typeof window.fetchConfig !== 'function') {
    window.fetchConfig = function (type) {
      return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/' + (type || 'json') } };
    };
  }
  if (typeof window.debounce !== 'function') {
    window.debounce = function (fn, wait) {
      var t;
      return function () {
        var args = arguments, self = this;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(self, args); }, wait);
      };
    };
  }
  if (!window.CartPerformance) {
    var mark = function (n) { try { return performance.mark(n); } catch (e) { return { name: n }; } };
    window.CartPerformance = {
      createStartingMarker: function (name) { return mark('cart-performance:' + name + ':start'); },
      measureFromEvent: function () {},
      measureFromMarker: function () {},
      measure: function (name, cb) { cb(); }
    };
  }
  if (!window.HTMLUpdateUtility) {
    window.HTMLUpdateUtility = {
      setInnerHTML: function (element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach(function (old) {
          var s = document.createElement('script');
          Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
          s.appendChild(document.createTextNode(old.innerHTML));
          old.parentNode.replaceChild(s, old);
        });
      },
      viewTransition: function (oldNode, newContent, pre, post) {
        (pre || []).forEach(function (cb) { cb(newContent); });
        var wrap = document.createElement('div');
        window.HTMLUpdateUtility.setInnerHTML(wrap, newContent.outerHTML);
        var newNode = wrap.firstChild, key = Date.now();
        oldNode.querySelectorAll('[id], [form]').forEach(function (el) {
          if (el.id) el.id = el.id + '-' + key;
          if (el.form) el.setAttribute('form', el.form.getAttribute('id') + '-' + key);
        });
        oldNode.parentNode.insertBefore(newNode, oldNode);
        oldNode.style.display = 'none';
        (post || []).forEach(function (cb) { cb(newNode); });
        setTimeout(function () { oldNode.remove(); }, 500);
      }
    };
  }
})();
